import React, { useEffect, useRef, useState } from 'react';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Autocomplete from '@deprecated-ui/common/Autocomplete';
import Tag from '@deprecated-ui/common/Tag';
import Input from '@deprecated-ui/common/Input';
import { useDispatch, useSelector } from 'react-redux';
import valuationSlice, {
  valuationEffects,
  valuationSelectors,
} from 'features/valuation/slice';
import { ICompanyEntityCompanySymbol } from 'features/valuation/interfaces';
import styled from 'styled-components';
import { Label } from '../../styled';

const { Tag: TagCompany } = Tag;

const SAutocomplete = styled(Autocomplete)`
  margin-top: 10px;
  margin-bottom: 15px;
`;

const prepareSuggestionData = (companies: ICompanyEntityCompanySymbol[]) =>
  companies.map((company) => {
    const { name, desc, id } = company;

    return {
      value: name,
      companyid: id,
      label: (
        <Flex align="center">
          <TagCompany size="s" type="grey">
            {name}
          </TagCompany>
          {/* @ts-expect-error */}
          <Text ml="10px" size="13px" ellipsis>
            {desc}
          </Text>
        </Flex>
      ),
    };
  });

const AutocompleteSymbol = () => {
  const [companyOptions, setCompanyOptions] = useState([]);

  const dispatch = useDispatch();

  const { getCompanySymbol, getDefaultValuationMetric } = valuationEffects;

  const {
    setValuationSymbol,
    resetValuationResult,
    setValuationMetricKeyword,
  } = valuationSlice.actions;

  const {
    companySymbols,
    valuationResult,
    valuationSymbol,
    valuationMetricKeyword,
  } = useSelector(valuationSelectors);

  const delayTimer = useRef(undefined);

  const {
    data: { symbol },
  } = valuationResult;

  const onTypeHandler = (e) => {
    const typedVal: string = e.target.value;
    dispatch(setValuationMetricKeyword(typedVal));

    // Reset result on change
    if (symbol || valuationSymbol.symbol) {
      dispatch(resetValuationResult());
      dispatch(setValuationSymbol({ id: '', symbol: '' }));
    }

    // Trigger search options
    if (typedVal.length !== 0) {
      clearTimeout(delayTimer.current);
      delayTimer.current = setTimeout(() => {
        dispatch(getCompanySymbol(typedVal));
      }, 500);
    } else {
      setCompanyOptions([]);
    }
  };

  const onClickAutocomplete = (companySymbol: string, options) => {
    const { companyid } = options;

    dispatch(setValuationMetricKeyword(companySymbol));
    dispatch(resetValuationResult());
    dispatch(setValuationSymbol({ id: companyid, symbol: companySymbol }));
    dispatch(getDefaultValuationMetric({ symbol: companySymbol }));
  };

  useEffect(() => {
    const {
      data: { company },
    } = companySymbols;

    if (company?.length) {
      const companies = prepareSuggestionData(company);

      setCompanyOptions(companies);
    }
  }, [companySymbols]);

  return (
    <>
      <Label>Valuation Metric</Label>
      <SAutocomplete
        options={companyOptions}
        // @ts-expect-error
        dropdownStyles={{
          boxShadow: 'unset',
          minWidth: '260px',
          maxWidth: '260px',
          width: 'auto',
        }}
        onSelect={onClickAutocomplete}
        value={valuationMetricKeyword}
      >
        <Input
          value={valuationMetricKeyword}
          placeholder="Type the stock symbol ..."
          onChange={onTypeHandler}
          width="100%"
          required
        />
      </SAutocomplete>
    </>
  );
};

export default AutocompleteSymbol;
